import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import EnrichmentEditor from '../../../components/Editor/EnrichmentEditor';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			editableEnrichments,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { page, id } = ownProps;
	const { type, isThemedItem } = editableEnrichments[page][id];

	return {
		type,
		isActive: id === activeItem.id && page === activeItem.page,
		isEditPanelDisplayed,
		isThemedItem,
	};
};

export default connect(mapStateToProps)(EnrichmentEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EnrichmentEditor/index.tsx